<script>
  import Notes from './Chapter/Notes.svelte';
  import { IS_INTERFACE_VISIBLE, IS_FINISHED } from '../stores.js';

  let isInterfaceVisible;
  IS_INTERFACE_VISIBLE.subscribe(v => {
    isInterfaceVisible = !v;
  });

  let isFilmFinished;
  IS_FINISHED.subscribe(v => {
    isFilmFinished = v;
  });

  function pause () { window.pause(); }
  function play () {
    // We need this check as clicking on the chapter overview button in the sidebar trigger the hover event of the sidebar
    if (isInterfaceVisible) {
      window.play();
    }
  }
</script>

<aside
	class="page-sidebar"
	class:isInterfaceVisible={isInterfaceVisible}
	class:isFilmFinished={isFilmFinished}
	on:mouseenter={pause}
	on:mouseleave={play}>
	<section class="page-chapter">
    <Notes />
  </section>
</aside>
